export default function useChartSync({
  charts,
  getSeriesByPanelId,
  timeIndexes,
  currentTimeIndex,
  emit,
  options = {},
}) {
  const { initTimeIndexOnRangeChange = false } = options

  const makeSyncVisible = chartId => range => {
    if (initTimeIndexOnRangeChange && !currentTimeIndex.value) {
      currentTimeIndex.value = range.to
    }
    charts.forEach((chart, idx) => {
      if (chart && chartId !== idx) chart.timeScale().setVisibleLogicalRange(range)
    })
    if (chartId === 0) emit('timeRangeChange', range)
  }

  const makeSyncCrosshair = chartId => param => {
    if (!param.time) {
      charts.forEach(chart => chart && chart.clearCrosshairPosition())

      return
    }

    if (timeIndexes[param.time] !== undefined) {
      currentTimeIndex.value = timeIndexes[param.time]
    }

    const thisSeries = getSeriesByPanelId(chartId)
    const dataPoint = thisSeries ? param.seriesData.get(thisSeries) : null

    if (!dataPoint) {
      charts.forEach(chart => chart && chart.clearCrosshairPosition())

      return
    }

    // Candlestick series uses .close; line/baseline series use .value
    const value = dataPoint.close ?? dataPoint.value

    charts.forEach((chart, idx) => {
      if (chart && chartId !== idx) {
        chart.setCrosshairPosition(value, dataPoint.time, getSeriesByPanelId(idx))
      }
    })
  }

  const bindSync = (chart, chartId) => {
    chart.timeScale().subscribeVisibleLogicalRangeChange(makeSyncVisible(chartId))
    chart.subscribeCrosshairMove(makeSyncCrosshair(chartId))
  }

  return { bindSync }
}
